import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
	return <MuiAlert elevation={6} variant='filled' {...props} />;
}

export const BaseSnackbar = ({ open, message, color }) => {
	return (
		<Snackbar open={open} autoHideDuration={4000}>
			<Alert color={color}>{message}</Alert>
		</Snackbar>
	);
};

BaseSnackbar.propTypes = {
	open: PropTypes.bool.isRequired,
	message: PropTypes.string.isRequired,
	color: PropTypes.string
};

export default BaseSnackbar;
